import { logout } from '../auth.service';
import Login from '../../pages/Login';

const Coruja = () =>
{    
    localStorage.setItem("tenantId", "coruja");
    localStorage.setItem("logoVertical", "logoCoruja");
    logout();
    
    return Login();
};

export default Coruja;